import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from "../../../store";
import { DownloadResume } from '../resume_output';

const Resume6 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="max-w-4xl mx-auto my-10 bg-white shadow-lg rounded-lg overflow-hidden p-8" ref={resumeRef}>
        <header className="flex justify-between items-center border-b-2 border-[#28a745] pb-4 mb-8">
          <div>
            <h1 className="text-4xl font-bold text-[#333]">{ResumeStore?.resumeBuilder.personalDetails.firstName} <span className="text-[#28a745]">{ResumeStore?.resumeBuilder.personalDetails.lastName}</span></h1>
            <p className="text-xl text-[#333]">{ResumeStore?.resumeBuilder.personalDetails.jobTitle}</p>
          </div>
          <div className="text-center">
            <img className="rounded-full w-40 h-40 object-cover" src={
              ResumeStore?.resumeBuilder?.profile ??
              "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
            } 
            alt="Profile" />
          </div>
        </header>
        <section className="flex">
          <div className="w-[60%] pr-8 border-r-2 border-gray-200">
            <section className="mb-8">
              <h2 className="text-[#28a745] text-2xl mb-4">Profile</h2>
              <p className="text-[#333]">{ResumeStore?.resumeBuilder?.profileSummary}</p>
            </section>
            <section className="mb-8">
              <h2 className="text-[#28a745] text-2xl mb-4">EDUCATION HISTORY </h2>
              {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                <div key={index} className="mb-6">
                  <h3 className="text-xl text-[#333] font-bold">{edu.degree}</h3>
                  <p className="text-[#333]">{edu.school}</p>
                  <p className="text-[#333]">{edu.startDate} - {edu.endDate}</p>
                  <p className="text-[#333]">{edu.description}</p>
                </div>
              ))}
            </section>
          </div>
          <div className="w-[40%] pl-8">
            <section className="mb-8">
              <h2 className="text-[#28a745] text-2xl mb-4">SALES EXECUTIVE</h2>
              <p className="text-[#28a745]"><a href={ResumeStore?.resumeBuilder.websites[0]?.link} className="text-[#28a745]">{ResumeStore?.resumeBuilder.websites[0]?.label}</a></p>
              <p className="text-[#28a745]"><a href={`mailto:${ResumeStore?.resumeBuilder.personalDetails.email}`} className="text-[#28a745]">{ResumeStore?.resumeBuilder.personalDetails.email}</a></p>
              <p className="text-[#28a745]">{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
            </section>
            <section className="mb-8">
              <h2 className="text-[#28a745] text-2xl mb-4">RELEVANT SKILLS</h2>
              <ul className="list-none p-0">
                {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                  <li key={index} className="bg-[#e9f5e9] my-2 p-2 rounded text-[#333]">{skill}</li>
                ))}
              </ul>
            </section>
            <section>
              <h2 className="text-[#28a745] text-2xl mb-4">WORK EXPERIENCE</h2>
              {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
                <div key={index} className="mb-6">
                  <h3 className="text-xl text-[#333] font-bold">{job.jobTitle}</h3>
                  <p className="text-[#333]">{job.company}</p>
                  <p className="text-[#333]">{job.description}</p>
                  <p className="text-[#333]">{job.startDate} - {job.endDate}</p>
                  <ul className="list-disc pl-6">
                    {job.responsibilities && job.responsibilities.map((responsibility, idx) => (
                      <li key={idx} className="text-[#333]">{responsibility}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </section>
          </div>
        </section>
      </div>
    </>
  ));
}

export default Resume6;
